import CssBaseline from "@mui/material/CssBaseline";
import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
import { Footer } from "../../Components/Footer";
import EventsCalendar from "../../Components/calendar/Calendar";

export default function Callendar() {
  useDocumentTitle("Kalendarz VR");

  return (
    <>
      <EventsCalendar userRole="admin" />
      <CssBaseline />

      <Footer />
    </>
  );
}
